import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IAppNotification } from '../types/app-notification.type';

interface AppNotificationState extends BaseDataReducerV2InitialState<IAppNotification> {
  perPage: number;
  unreadNotificationCount: number;
}

const { initialState, AC, reducer } = basedDataReducerV2<IAppNotification, AppNotificationState>('app-notification');

const appNotificationState: AppNotificationState = {
  ...initialState,
  perPage: 10,
  unreadNotificationCount: 0,
};

export const appNotification = createSlice({
  name: 'appNotification',
  initialState: appNotificationState,
  reducers: {
    setUnreadNotificationCount: (state, action: PayloadAction<number>) => {
      state.unreadNotificationCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as AppNotificationState, action);
    });
  },
});
export const AppNotificationAC = AC;
export const setAppNotificationCurrentPage = AC.setCurrentPage;
export const { setUnreadNotificationCount } = appNotification.actions;
